module.exports = __webpack_public_path__ + "static/media/keinBild.2b171df4.png";